module.exports = __webpack_public_path__ + "img/07-LeProcess-03.eafd226f.png";